// File: src/utils/downloadUtils.js
// Copyright (c) 2025 DefoAI UG (haftungsbeschränkt)
//
// Utility functions for file downloads.

/**
 * Downloads content as a file in the browser.
 * @param {string} content - The file content
 * @param {string} filename - The download filename
 * @param {string} mimeType - The MIME type (e.g., 'application/json')
 */
export const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

/**
 * Downloads data as a JSON file.
 * @param {Array|Object} data - The data to download
 * @param {string} entityType - Entity type for filename (e.g., 'users', 'audit-logs')
 * @param {Object} metadata - Optional metadata to include (e.g., filters applied)
 * @returns {Object} - { success: boolean, filename: string, count: number }
 */
export const downloadAsJson = (data, entityType, metadata = {}) => {
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const filename = `defo-ads-admin-${entityType}-${timestamp}.json`;

    const exportData = {
        meta: {
            exportedAt: new Date().toISOString(),
            entityType,
            count: Array.isArray(data) ? data.length : 1,
            ...metadata
        },
        data
    };

    const jsonContent = JSON.stringify(exportData, null, 2);
    downloadFile(jsonContent, filename, 'application/json');

    return {
        success: true,
        filename,
        count: exportData.meta.count
    };
};
